import { Callout } from '@/components/callouts/Callout';

interface PriceReferenceCalloutProps {
  selectedCurrencyName?: string;
  selectedCurrencyDecimals?: number;
  hasSelectedCurrency: boolean;
  triggerType?: string;
}

export default function PriceReferenceCallout({
  selectedCurrencyName,
  selectedCurrencyDecimals,
  hasSelectedCurrency,
  triggerType = 'trigger',
}: PriceReferenceCalloutProps) {
  return (
    <Callout
      type="info"
      title={`${
        selectedCurrencyName || 'The price reference token'
      } will be used to reference the price & decimals of the token to hold`}
      body={
        hasSelectedCurrency
          ? `Make sure the token you are selecting has ${selectedCurrencyDecimals} decimals`
          : `Make sure the amount coming from the ${triggerType} has the same decimals as the currency selected here`
      }
    />
  );
}
